/**
 * Join condizionale di classi: scarta falsy e unisce con uno spazio.
 * Niente dipendenze (clsx/twMerge non sono in progetto) — basta per le varianti del DS.
 */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ')
}
